
const state = {
  id: null,
  body: '',
  commentable_id: undefined,
  commentable_type: '',
  data: {},
  public: false,
  user_id: undefined,
}

export const requiredFields = [
  { key: 'body' },
  { key: 'commentable_id' },
  { key: 'commentable_type' },
]

export default state
